// tslint:disable
/**
 * Webitel engine API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 23.07.0
 * Contact: support@webitel.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var EngineRoutingSchemaType;
(function (EngineRoutingSchemaType) {
    EngineRoutingSchemaType["Default"] = "default";
    EngineRoutingSchemaType["Voice"] = "voice";
    EngineRoutingSchemaType["Chat"] = "chat";
    EngineRoutingSchemaType["Processing"] = "processing";
    EngineRoutingSchemaType["Service"] = "service";
})(EngineRoutingSchemaType || (EngineRoutingSchemaType = {}));
//# sourceMappingURL=engine-routing-schema-type.js.map